import notionface from '../assets/images/image.png';


export function About () {
    return (
        <div className="flex flex-col justify-center bg-gray-100 scroll-mt-14 space-y-6 px-6 py-10" id="about">
            <h1 className="text-3xl font-bold text-red-600 w-11/12 lg:w-[954px] self-center font-dmsans">About Me</h1>
            <div className="text-black w-11/12 lg:w-[954px] self-center py-6 flex flex-col lg:flex-row max-lg:space-y-6 lg:space-x-20">
                <img src={notionface} alt="headshot" className="rounded-full w-[300px] h-[300px] bg-red-500"/>
                <div className="flex flex-col justify-center space-y-6">
                    <div className="space-y-2">
                        <h2 className="text-xl font-semibold font-dmsans">Hi, I'm <span className="text-red-500">Chau</span>!</h2>
                        <p className="text-base font-roboto font-light">
                            I'm a student at the University of Cincinnati pursuing a <span className="underline decoration-indigo-400 underline-offset-4">Computer Science</span> degree with a minor in <span className="underline decoration-indigo-400 underline-offset-4">Mathematics</span>.
                        </p>
                        <p className="text-base font-roboto font-light">
                            I'm passionate about creating impactful software and enjoy tackling problems in innovative ways.
                            I have experience in <span className="underline decoration-red-400 underline-offset-4">software development</span>, <span className="underline decoration-red-400 underline-offset-4">web development</span>, and <span className="underline decoration-red-400 underline-offset-4">automation</span>, and I love diving into new technologies.
                        </p>
                        <p className="text-base font-roboto font-light">
                            Outside of coding, you can find me at <span className="underline decoration-green-400 underline-offset-4">hackathons</span>, engaging with tech communities, or savoring a good cup of <span className="underline decoration-green-400 underline-offset-4">matcha</span>.
                        </p>
                    </div>
                    
                    {/* <div className="space-y-2">
                        <h3 className="text-lg font-dmsans font-semibold">My Skillset</h3>
                        <ul className="list-disc list-inside marker:text-red-600 space-y-1 text-sm font-roboto font-light">
                            <li>Programming Languages: JavaScript, TypeScript, C++, Python</li>
                            <li>Frameworks & Libraries: React, Astro, Next.js, Node.js, Express, GraphQL, Flask</li>
                            <li>Tools & Platforms: Git, GitHub, Docker, Postman, PostgreSQL, Cypress</li>
                        </ul>
                    </div> */}

                </div>
            </div>
        </div>        
    )
}

